import React from 'react';

import Drawer from '@mui/material/Drawer';

import { useTranslation } from "react-i18next";

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import OpChecklist from '../CourbeService/OpChecklist.js'


const BenchmarksDrawer = (props) => {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  let list = () => (
    <div
      style={{ width: "350px" }}
      role="presentation"
    >
      <h2 className="pt-2 pb-2 text-center">{t('compareperiods.filters')}</h2>

      <div className="overflow-y-scroll pt-1 ps-2" style={{ maxHeight: "90vh" }}>

        <h3 className="pt-4">{t('trends.days')}</h3>
        <div className="col pb-3">
          <div type="button" className={props.service == "tous" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.all')}</div>
          <div type="button" className={props.service == "se" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.week')}</div>
          <div type="button" className={props.service == "fds" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.weekends')}</div>
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('compareperiods.period')}</h3>
          <div className="col">
            {['all', 'morning', 'am', 'offpeak', 'pm', 'evening'].map((buttonId) => (
              <div
                type="button"
                key={buttonId}
                className={props.period.includes(buttonId) ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                onClick={(e) => props.handleMultiPeriodClick(e, props.t, props.period, props.setPeriod, buttonId)}
              >
                {t(`compareperiods.${buttonId}`)}
              </div>
            ))}
          </div>
        </div>

        <h3 className="pt-3">{t('benchmarks.agencies')}</h3>
        <div className="col pb-3">
              <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
                <div className="col-12 overflow-y-scroll border" style={{ backgroundColor: "white", maxHeight: "440px" }}>
                  <OpChecklist
                    groups={props.groups}
                    handleToggle={props.handleToggle}
                    properties={props.properties}
                  />
                </div>
              </div>
            </div>

        {props.error==true ? 
      <Stack className="pt-2 pb-2" sx={{ width: '100%' }} spacing={2}>
        <Alert severity="error">{t('compareperiods.alert')}</Alert>
      </Stack>
      :''}

        <div className="text-center pt-3 pb-3">
          <div type="button" className="btn btn-primary me-1" onClick={props.handleFilters} >{t('compareperiods.apply')}</div>
        </div>

      </div>

    </div>

  );

  return (
    <Drawer anchor={'left'} open={props.open} onClose={props.toggle}>
      {list('left')}
    </Drawer>
  )

}

export default BenchmarksDrawer;